import React from 'react';
import type { ChangeEvent } from 'react';
import type { TravelerFormValues } from '../../../../api/reservationInfo';
import type { TravelerFieldRules } from '../utils';

type Props = {
  travelerFieldRules: TravelerFieldRules;
  traveler: TravelerFormValues;
  travelerErrors: Partial<Record<keyof TravelerFormValues, string>>;
  onTextChange: (field: keyof TravelerFormValues) => (e: ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
};

const ReservationInfoAirKanaFields = ({
  travelerFieldRules,
  traveler,
  travelerErrors,
  onTextChange,
  disabled
}: Props) => {
  const { isRequired, isVisible } = travelerFieldRules;
  if (!isVisible('flight_first_name_kana') && !isVisible('flight_last_name_kana')) {
    return null;
  }

  const styles = getStyles();

  return (
    <>
      <div style={styles.formGroup}>
        <label htmlFor="traveler-flightLastNameKana" style={styles.label}>
          姓（カナ）
          {(isRequired('flight_first_name_kana') || isRequired('flight_last_name_kana')) && (
            <span style={styles.required}>*</span>
          )}
        </label>
        <input
          id="traveler-flightLastNameKana"
          type="text"
          style={{
            ...styles.input,
            ...(travelerErrors.flightLastNameKana ? styles.inputError : {})
          }}
          placeholder="例：ヤマダ"
          value={traveler.flightLastNameKana}
          onChange={onTextChange('flightLastNameKana')}
          disabled={disabled}
        />
        {travelerErrors.flightLastNameKana && (
          <span style={styles.errorText}>{travelerErrors.flightLastNameKana}</span>
        )}
      </div>

      <div style={styles.formGroup}>
        <label htmlFor="traveler-flightFirstNameKana" style={styles.label}>
          名（カナ）
          {(isRequired('flight_first_name_kana') || isRequired('flight_last_name_kana')) && (
            <span style={styles.required}>*</span>
          )}
        </label>
        <input
          id="traveler-flightFirstNameKana"
          type="text"
          style={{
            ...styles.input,
            ...(travelerErrors.flightFirstNameKana ? styles.inputError : {})
          }}
          placeholder="例：タロウ"
          value={traveler.flightFirstNameKana}
          onChange={onTextChange('flightFirstNameKana')}
          disabled={disabled}
        />
        {travelerErrors.flightFirstNameKana && (
          <span style={styles.errorText}>{travelerErrors.flightFirstNameKana}</span>
        )}
      </div>
    </>
  );
};

const getStyles = (): Record<string, React.CSSProperties> => ({
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '6px',
    color: '#333'
  },
  required: {
    color: '#e74c3c',
    marginLeft: '4px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none'
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer'
  },
  inputError: {
    borderColor: '#e74c3c'
  },
  errorText: {
    color: '#e74c3c',
    fontSize: '12px',
    marginTop: '4px',
    display: 'block'
  }
});

export default ReservationInfoAirKanaFields;
